import type * as THREE from "three";
import { createSphere } from "./createSphere";

function createPositionHelper({ color }: { color: THREE.ColorRepresentation }) {
  const mesh = createSphere({ color });

  const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];

  for (const material of materials) {
    material.transparent = true;
    material.depthTest = false;
    material.depthWrite = false;
  }

  mesh.renderOrder = 9999;

  return mesh;
}

export { createPositionHelper };
